export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10427.0a1889a9.jpg";